import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const reqUrl = `${BASE_URL}/login/line`;

export const activeRichMenu = async (token, params) => {
  try {
    const response = await axios.post(`${reqUrl}`, {
      token,
      ...params,
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getLineLoginUrl = async (kw, content) => {
  try {
    const response = await axios.post(`${reqUrl}/register`, {
      keyword: kw,
      content,
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};

export const completeLineLogin = async (code, state) => {
  try {
    const response = await axios.post(`${reqUrl}/complete`, {
      code,
      state,
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};
